import React, { PureComponent, Children } from 'react';
import { getImageFileName } from '../../../utils';

interface IBackroundImageElementProps {
  classNames?: string[];
  tag?: any;
  imageName: string;
  extension?: string;
  dynamic?: boolean;
  [key: string]: any;
}

interface IImageState {
  src: string;
}

export default class BackroundImageElement extends PureComponent<
  IBackroundImageElementProps,
  IImageState
> {
  private imageRef: React.MutableRefObject<HTMLElement>;
  constructor(props: IBackroundImageElementProps) {
    super(props);
    this.state = {
      src: require(`../../../assets/${this.props.imageName}${this.props.extension ? `.${this.props.extension}` : ""}`)
    };
    this.imageRef = React.createRef();
  }

  componentDidMount() {
    const isPrerendered = window.__PRERENDER_INJECTED !== undefined;
    const imageFileName =
      this.props.dynamic && getImageFileName(this.props.imageName);

    const src =
      this.props.dynamic && !isPrerendered
        ? window.dynamicImages[imageFileName]
        : this.imageRef.current.getAttribute('data-image');

    if (src.indexOf('$staticlink$') === -1 && src.indexOf('http') !== -1) {
      this.setState({ src });
    }
  }

  render() {
    const { tag: Tag = 'div', classNames, children, imageName, ...props } = this.props;
    const { src } = this.state;
    const classes = classNames ? classNames.join(' ') : '';
    const style = {
      backgroundImage: `url(${src})`
    };

    return (
      <Tag
        ref={this.imageRef}
        className={classes}
        data-image={src}
        style={style}
        {...props}
      >
        {children}
      </Tag>
    );
  }
}
